import script from "./LiffLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiffLayout.vue?vue&type=script&setup=true&lang=ts"

import "./LiffLayout.vue?vue&type=style&index=0&id=6902f39e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.5_vue@3.4.5_typescript@5.4.5__webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6902f39e"]])

export default __exports__